'use strict';

import { Operator } from '../../operator/enum/operator';

export default [
    '$utils',
    '$filterUtils',
    ($utils, $filterUtils) => {
        let filters = getDefaultFilters();

        function getFilters() {
            return angular.copy(filters);
        }

        function setFilters(newFilters) {
            Object.assign(filters, angular.copy(newFilters));
        }

        function getDefaultFilters() {
            return {
                // sidebar filters
                type: null,
                // okved: [],
                activeProjectId: null,
                investmentSizeOperator: Operator.BETWEEN,
                investmentSize1: null,
                investmentSize2: null,
                workplacesOperator: Operator.BETWEEN,
                workplaces1: null,
                workplaces2: null,
                capitalInvestmentOperator: Operator.BETWEEN,
                capitalInvestment1: null,
                capitalInvestment2: null,
                personalInvestmentOperator: Operator.BETWEEN,
                personalInvestment1: null,
                personalInvestment2: null,
                yearOperator: Operator.BETWEEN,
                year1: null,
                year2: null,
                area: [],
            };
        }

        function getAllFilters() {
            return Object.assign({}, getFilters());
        }

        function collectFilterDto(filters) {
            const filterDto = [];
            if (Array.isArray(filters.area) && filters.area.length) {
                filterDto.push(`'AREA' IN '${filters.area.map(n => "" + n.id).join(';')}'`);
            }
            if (filters.type != null && filters.type.id != null) {
                filterDto.push(`'TYPE' IN '${filters.type.id}'`);
            }
            if (filters.investmentSize1 != null || filters.investmentSize2 != null) {
                filterDto.push(`'INVESTMENT' ${filters.investmentSizeOperator} '${filters.investmentSize1}${filters.investmentSizeOperator === Operator.BETWEEN ? ';' + filters.investmentSize2 : ''}'`);
            }
            if (filters.workplaces1 != null || filters.workplaces2 != null) {
                filterDto.push(`'WORK_PLACES' ${filters.workplacesOperator} '${filters.workplaces1}${filters.workplacesOperator === Operator.BETWEEN ? ';' + filters.workplaces2 : ''}'`);
            }
            if (filters.capitalInvestment1 != null || filters.capitalInvestment2 != null) {
                filterDto.push(`'FACILITIES' ${filters.capitalInvestmentOperator} '${filters.capitalInvestment1}${filters.capitalInvestmentOperator === Operator.BETWEEN ? ';' + filters.capitalInvestment2 : ''}'`);
            }
            if (filters.personalInvestment1 != null || filters.personalInvestment2 != null) {
                filterDto.push(`'ENCLOSURE' ${filters.personalInvestmentOperator} '${filters.personalInvestment1}${filters.personalInvestmentOperator === Operator.BETWEEN ? ';' + filters.personalInvestment2 : ''}'`);
            }
            if (filters.year1 != null || filters.year2 != null) {
                filterDto.push(`'PERIOD' ${filters.yearOperator} '${filters.year1}${filters.yearOperator === Operator.BETWEEN ? ';' + filters.year2 : ''}'`);
            }
            if (filters.activeProjectId != null) {
                filterDto.push(`EXTRA:'project' EQ '${filters.activeProjectId}'`);
            }
            return filterDto;
        }

        return {
            filters,
            setFilters,
            getFilters,
            getDefaultFilters,

            getAllFilters,

            collectFilterDto,
        };
    },
];
